/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PaginatedQuestionsDto from '../model/PaginatedQuestionsDto';
import QuestionDto from '../model/QuestionDto';
import QuestionInputDto from '../model/QuestionInputDto';

/**
* Question service.
* @module api/QuestionApi
* @version v0
*/
export default class QuestionApi {

    /**
    * Constructs a new QuestionApi. 
    * @alias module:api/QuestionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createQuestion operation.
     * @callback module:api/QuestionApi~createQuestionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/QuestionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new question
     * @param {module:model/QuestionInputDto} questionInputDto 
     * @param {module:api/QuestionApi~createQuestionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/QuestionDto}
     */
    createQuestion(questionInputDto, callback) {
      let postBody = questionInputDto;
      // verify the required parameter 'questionInputDto' is set
      if (questionInputDto === undefined || questionInputDto === null) {
        throw new Error("Missing the required parameter 'questionInputDto' when calling createQuestion");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = QuestionDto;
      return this.apiClient.callApi(
        '/api/private/question', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteQuestionById operation.
     * @callback module:api/QuestionApi~deleteQuestionByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a question by ID
     * @param {Number} id ID of the question to delete
     * @param {module:api/QuestionApi~deleteQuestionByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteQuestionById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteQuestionById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/question/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getQuestionById operation.
     * @callback module:api/QuestionApi~getQuestionByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/QuestionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a question by ID
     * @param {Number} id ID of the question to update
     * @param {module:api/QuestionApi~getQuestionByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/QuestionDto}
     */
    getQuestionById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getQuestionById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = QuestionDto;
      return this.apiClient.callApi(
        '/api/private/question/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getQuestions operation.
     * @callback module:api/QuestionApi~getQuestionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedQuestionsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all questions
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {module:api/QuestionApi~getQuestionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedQuestionsDto}
     */
    getQuestions(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedQuestionsDto;
      return this.apiClient.callApi(
        '/api/private/question', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateQuestionById operation.
     * @callback module:api/QuestionApi~updateQuestionByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/QuestionDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing question
     * Update an existing question by ID
     * @param {Number} id ID of the question to update
     * @param {module:model/QuestionDto} questionDto 
     * @param {module:api/QuestionApi~updateQuestionByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/QuestionDto}
     */
    updateQuestionById(id, questionDto, callback) {
      let postBody = questionDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateQuestionById");
      }
      // verify the required parameter 'questionDto' is set
      if (questionDto === undefined || questionDto === null) {
        throw new Error("Missing the required parameter 'questionDto' when calling updateQuestionById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = QuestionDto;
      return this.apiClient.callApi(
        '/api/private/question/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
